
import { oz } from '@weft/utils';
import { UnlimitedDurationSchema } from '../../primitives/unlimited-duration-schema';

const RegularPlanDuration = oz.number().positive();
const AdvancedPlanDuration = RegularPlanDuration.or(UnlimitedDurationSchema).openapi('PlanDuration');

const documentationCodegen = typeof process !== 'undefined' && !!process.env['DOCUMENTATION_GEN'];

export const PlanDurationSchema = documentationCodegen
  ? RegularPlanDuration
  : AdvancedPlanDuration;

export type PlanDuration = oz.infer<typeof AdvancedPlanDuration>;